(function () {
  document.querySelectorAll('[data-recipe-page-lola]').forEach(function (section) {
    initShare(section);
  });

  // Same share popup as the old recipes-blog-lola modal, but the shared
  // URL is simply the real, current page URL — no "?recipe=" param and
  // no reopen-on-load logic needed, since this page IS the recipe now.
  function initShare(section) {
    var sharePopup = section.querySelector('[data-recipe-page-share-popup]');
    var shareTrigger = section.querySelector('[data-recipe-page-share-trigger]');
    var shareCloseTriggers = Array.prototype.slice.call(
      section.querySelectorAll('[data-recipe-page-share-close]')
    );
    var shareCopyBtn = section.querySelector('[data-recipe-page-share-copy]');
    var shareCopyLabel = section.querySelector('[data-recipe-page-share-copy-label]');

    if (!sharePopup || !shareTrigger) return;

    function shareUrl() {
      return window.location.href;
    }

    function openShare() {
      var url = shareUrl();
      var title = document.title;
      var text = title + ' — LOLA Rezept';

      var links = {
        whatsapp: 'https://wa.me/?text=' + encodeURIComponent(text + ' ' + url),
        facebook: 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url),
        x: 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(text),
        email: 'mailto:?subject=' + encodeURIComponent(text) + '&body=' + encodeURIComponent(url)
      };

      Object.keys(links).forEach(function (key) {
        var el = sharePopup.querySelector('[data-recipe-page-share-link="' + key + '"]');
        if (el) el.setAttribute('href', links[key]);
      });

      sharePopup.classList.add('is-open');
      sharePopup.setAttribute('aria-hidden', 'false');
      document.addEventListener('keydown', onKeydown);
    }

    function closeShare() {
      sharePopup.classList.remove('is-open');
      sharePopup.setAttribute('aria-hidden', 'true');
      document.removeEventListener('keydown', onKeydown);
    }

    function onKeydown(event) {
      if (event.key === 'Escape') closeShare();
    }

    shareTrigger.addEventListener('click', openShare);

    shareCloseTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', closeShare);
    });

    sharePopup.addEventListener('click', function (event) {
      var card = sharePopup.querySelector('.recipe-page-lola__share-card');
      if (card && !card.contains(event.target)) closeShare();
    });

    if (shareCopyBtn) {
      shareCopyBtn.addEventListener('click', function () {
        var url = shareUrl();
        var originalLabel = shareCopyLabel ? shareCopyLabel.textContent : '';

        function showCopied() {
          if (!shareCopyLabel) return;
          var copiedText = shareCopyBtn.getAttribute('data-recipe-page-share-copied-text') || 'Kopiert!';
          shareCopyLabel.textContent = copiedText;
          window.setTimeout(function () {
            shareCopyLabel.textContent = originalLabel;
          }, 1800);
        }

        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(url).then(showCopied, function () {
            /* clipboard write failed (e.g. no permission) — fail silently */
          });
        } else {
          var tempInput = document.createElement('input');
          tempInput.value = url;
          document.body.appendChild(tempInput);
          tempInput.select();
          try {
            document.execCommand('copy');
            showCopied();
          } catch (e) {
            /* copy failed — fail silently */
          }
          document.body.removeChild(tempInput);
        }
      });
    }
  }
})();
